module.exports = __webpack_public_path__ + "static/media/page05_front.6886dc91.png";